import { TAXES_TYPES } from "@utils/Constants";
import { getEmailYupValidation } from "@utils/Forms";
import { generateSelectOption } from "@utils/Utils";

const SendToEmailFormConfig = {
    submit: {
        label: "Enviar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "email",
                        "name": "emails",
                        "label": "Correo Electronico",
                        "labelSizing": {
                            "sm": 2
                        },
                        "options": generateSelectOption(TAXES_TYPES),
                        "validation": getEmailYupValidation()
                    }
                ]
            ]
        }
    ],
};


export default SendToEmailFormConfig;